import { FGLayout, FGToastContainer } from '@fg/design-system';
import Footer from 'Footer';
import Header from 'Header';
import { ReactNode, useEffect } from 'react';
import Sidebar from 'Sidebar';
import GQPopupManager from 'components/GQPopup/GQPopupManager';
import { forceOldDomain, isOldDomain } from 'services/configService';
import DomainMigrationLayout from 'components/DomainMigrationLayout';
import { inject } from 'mobx-react';
import rootStore, { IMobxRootState } from 'RootStore';
import * as IPC from 'components/eventsFeed/EventsWorkerIPC';
import usePageId from 'hooks/usePageId';

type Props = { children: ReactNode; activeGroupId?: string };

const Layout = inject(({ settingsStore }: IMobxRootState) => {
    return {
        activeGroupId: settingsStore.activeGroupId,
    };
})(({ children, activeGroupId }: Props) => {
    const pageId = usePageId();

    useEffect(() => {
        const { eventsHandlerWorker } = rootStore.eventsFeedStore;
        eventsHandlerWorker.postMessage({
            code: IPC.E_EVENTS_WORKER_IPC_CODES.SET_ACTIVE_GROUP,
            activeGroupId,
        });
    }, [activeGroupId]);

    //todo: remove once old domain is deleted
    if (isOldDomain() || forceOldDomain) {
        return <DomainMigrationLayout>{children}</DomainMigrationLayout>;
    }
    return (
        <div data-pageid={pageId} style={{ height: '100%' }}>
            <FGLayout
                footer={<Footer />}
                header={<Header />}
                sidebar={<Sidebar />}>
                <GQPopupManager />
                <FGToastContainer />
                <div style={{ height: '100%' }} data-testid='content'>{children}</div>
            </FGLayout>
        </div>
    );
});

export default Layout;
